import { createFileRoute } from '@tanstack/react-router'
import React from 'react';
import { useNavigate, useParams, useRouterState } from '@tanstack/react-router';
import Layout from '@/components/Layout';
import { useI18n } from '@/hooks/useI18n';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeftIcon, PencilIcon } from '@heroicons/react/24/outline';

export default function EditMenuItemPage() {
    const { t } = useI18n();
    const navigate = useNavigate();
  const params = useParams({ strict: false });
  const routerState = useRouterState();
    const { id } = params;

    const handleBack = () => {
        navigate({ to: `/menus/${id}`});
    };

    const handleBackToList = () => {
        navigate({ to: '/menus'});
    };

    return (
        <Layout>
            <div className="space-y-6">
                {/* Header */}
                <div className="flex items-center gap-4">
                    <Button variant="ghost" onClick={handleBack} className="flex items-center gap-2">
                        <ArrowLeftIcon className="h-4 w-4" />
                        Back to Item Details
                    </Button>
                    <div>
                        <h1 className="text-3xl font-bold tracking-tight">
                            Edit Menu Item
                        </h1>
                        <p className="text-muted-foreground">
                            Modify menu item details and location variants
                        </p>
                    </div>
                </div>

                {/* Placeholder Content */}
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <PencilIcon className="h-5 w-5" />
                            Edit Menu Item Form
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="p-6 text-center text-muted-foreground">
                        <div className="space-y-4">
                            <PencilIcon className="h-16 w-16 mx-auto opacity-50" />
                            <div>
                                <h3 className="text-lg font-semibold text-foreground mb-2">
                                    Edit Menu Item Form
                                </h3>
                                <p>
                                    This form will allow you to edit menu items with:
                                </p>
                                <ul className="text-sm mt-2 space-y-1">
                                    <li>• Update basic information (name, description)</li>
                                    <li>• Modify pricing (base price, cost price)</li>
                                    <li>• Change category assignment</li>
                                    <li>• Update status and availability settings</li>
                                    <li>• Manage location-specific variants</li>
                                    <li>• Bulk update location pricing</li>
                                </ul>
                            </div>
                            <div className="pt-4">
                                <p className="text-sm italic mb-4">
                                    Form implementation coming soon...
                                </p>
                                <div className="flex gap-2 justify-center">
                                    <Button
                                        onClick={handleBack}
                                        variant="outline"
                                    >
                                        Back to Details
                                    </Button>
                                    <Button
                                        onClick={handleBackToList}
                                    >
                                        Back to Menu Items
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </Layout>
    );
}

export const Route = createFileRoute('/menus/$id/edit')({
  component: EditMenuItemPage,
})
